module.exports = __webpack_public_path__ + "img/wrcsfw-ldys-gsx.c953dc2b.png";